import { render } from "./DevMenu.vue?vue&type=template&id=294048a0&scoped=true&ts=true"
import script from "./DevMenu.vue?vue&type=script&lang=ts"
export * from "./DevMenu.vue?vue&type=script&lang=ts"

import "./DevMenu.vue?vue&type=style&index=0&id=294048a0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294048a0"]])

export default __exports__